import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import { mapRootElDataset } from './validation'

const rootEl = document.getElementById('qr-modules-manager')

Sentry.init({
  dsn: 'https://d26e842645801118d614b579f0e3f608@o255600.ingest.us.sentry.io/4508291835232256',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.captureConsoleIntegration({
      levels: ['error'],
    }),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

if (rootEl) {
  if (!rootEl.style.backgroundColor) rootEl.style.backgroundColor = 'rgb(255,255,255)'

  const dataset = mapRootElDataset(rootEl.dataset)

  ReactDOM.createRoot(rootEl).render(<App dataset={dataset} />)
} else {
  console.warn('No qr-modules-manager found')
}
